/* eslint-disable no-unused-vars */
// Stake-db 풀 상태
export enum STAKE_DB_POOL_STATE {
  WAITING = 0, // 대기
  FUNDRAIS_ING = 1, // 모금 중
  FUNDRAIS_ING_LOCKED = 2, // 모금 잠김
  FUNDRAIS_ING_STOPPED = 3, // 모금 중지
  FUNDRAIS_ING_FAILED = 4, // 모금 실패
  OPERATING = 5, // 운영 중
  OPERATING_CLOSED = 6, // 운영 종료
  OPERATING_STOPPED = 7, // 운영 중지
}

// 허용된 상태 전환 규칙
export const ALLOWED_STATE_TRANSITIONS: Record<number, number[]> = {
  [STAKE_DB_POOL_STATE.WAITING]: [STAKE_DB_POOL_STATE.FUNDRAIS_ING],
  [STAKE_DB_POOL_STATE.FUNDRAIS_ING]: [
    STAKE_DB_POOL_STATE.FUNDRAIS_ING_LOCKED,
    STAKE_DB_POOL_STATE.FUNDRAIS_ING_STOPPED,
    STAKE_DB_POOL_STATE.FUNDRAIS_ING_FAILED,
    STAKE_DB_POOL_STATE.OPERATING,
  ],
  [STAKE_DB_POOL_STATE.FUNDRAIS_ING_LOCKED]: [STAKE_DB_POOL_STATE.OPERATING],
  [STAKE_DB_POOL_STATE.OPERATING]: [
    STAKE_DB_POOL_STATE.OPERATING_CLOSED,
    STAKE_DB_POOL_STATE.OPERATING_STOPPED,
  ],
};
